export const ENTRY_SOURCE_TYPE_MANUAL = 'manual' as const;
export const ENTRY_SOURCE_TYPE_IMAGE_ANALYSIS = 'image_analysis' as const;
export const ENTRY_SOURCE_TYPE_TEXT_ANALYSIS = 'text_analysis' as const;
export const ENTRY_SOURCE_TYPE_REPORT = 'report' as const;
export const ENTRY_SOURCE_TYPE_TODO_CREATION = 'todo_creation' as const;
export const ENTRY_SOURCE_TYPE_EXTERNAL_ENTRY_FORM =
  'external_entry_form' as const;
export const ENTRY_SOURCE_TYPE_ENTRY_FORM_SUBMISSION =
  'entry_form_submission' as const;
export const ENTRY_SOURCE_TYPE_SCHEDULE_REGISTRATION =
  'schedule_registration' as const;

/** ステップ作成のトリガーとなったアクションの種別 */
export type StepCreationTriggerType =
  | typeof ENTRY_SOURCE_TYPE_MANUAL
  | typeof ENTRY_SOURCE_TYPE_IMAGE_ANALYSIS
  | typeof ENTRY_SOURCE_TYPE_TEXT_ANALYSIS
  | typeof ENTRY_SOURCE_TYPE_REPORT
  | typeof ENTRY_SOURCE_TYPE_TODO_CREATION
  | typeof ENTRY_SOURCE_TYPE_EXTERNAL_ENTRY_FORM
  | typeof ENTRY_SOURCE_TYPE_ENTRY_FORM_SUBMISSION
  | typeof ENTRY_SOURCE_TYPE_SCHEDULE_REGISTRATION;

/** エントリーフォームの種別: 内部エントリーフォーム */
export const ENTRY_FORM_ORIGIN_INTERNAL = 'internal' as const;
/** エントリーフォームの種別: 外部エントリーフォーム */
export const ENTRY_FORM_ORIGIN_EXTERNAL = 'external' as const;

/** エントリーフォームの種別（internal: 内部エントリーフォーム, external: 外部エントリーフォーム） */
export type EntryFormOriginType =
  | typeof ENTRY_FORM_ORIGIN_INTERNAL
  | typeof ENTRY_FORM_ORIGIN_EXTERNAL;
